import { RecipeVariantProps, sva } from "styled-system/css";

export const eventsWidgetRecipe = sva({
  slots: ["events"],
  base: {
    events: {
      gridGap: "500",
      w: "full",
    },
  },
  variants: {
    size: {
      mobile: {
        events: {
          gridTemplateRows: "460px 1fr",
        },
      },
      tablet: {
        events: {
          gridTemplateColumns: "auto 260px",
        },
      },
      desktop: {
        events: {
          gridTemplateColumns: "auto 260px",
        },
      },
      large: {
        events: {
          gridTemplateColumns: "auto 260px",
        },
      },
    },
    view: {
      month: {
        events: {
          gridTemplateColumns: "auto 260px",
        },
      },
      selectedDates: {
        events: {
          gridTemplateColumns: "auto",
        },
      },
    },
  },
  compoundVariants: [
    {
      size: "mobile",
      view: "month",
      css: {
        events: {
          gridTemplateColumns: "unset",
          gridTemplateRows: "460px 1fr",
        },
      },
    },
    {
      size: "mobile",
      view: "selectedDates",
      css: {
        events: {
          gridTemplateColumns: "unset",
          gridTemplateRows: "460px",
        },
      },
    },
  ],
  defaultVariants: {
    size: "mobile",
    view: "month",
  },
});

export type EventWidgetRecipeProps = RecipeVariantProps<
  typeof eventsWidgetRecipe
>;
